var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83203 8.99999C3.27975 8.99999 2.83203 8.55228 2.83203 7.99999C2.83203 7.63804 3.02762 7.30434 3.34343 7.12749L12.0111 2.27361C12.3146 2.10362 12.6847 2.10362 12.9883 2.27361L21.6559 7.12749C22.1378 7.39734 22.3097 8.00673 22.0398 8.4886C21.863 8.8044 21.5293 8.99999 21.1673 8.99999H19.9997V9.99999C19.9997 10.5523 19.552 11 18.9997 11L18.999 15.9991L19.9997 16C20.552 16 20.9997 16.4477 20.9997 17V18C21.552 18 21.9997 18.4477 21.9997 19V20C21.9997 20.5523 21.552 21 20.9997 21H3.99967C3.44738 21 2.99967 20.5523 2.99967 20V19C2.99967 18.4477 3.44738 18 3.99967 18V17C3.99967 16.4477 4.44738 16 4.99967 16L5.99903 15.9991L5.99967 11C5.44738 11 4.99967 10.5523 4.99967 9.99999V8.99999H3.83203ZM20.9997 19H3.99967V20H20.9997V19ZM19.9997 17H4.99967V18H19.9997V17ZM15.999 10.9991H13.999V15.9991H15.999V10.9991ZM10.999 10.9991H8.99903V15.9991H10.999V10.9991ZM7.99967 11H6.99967V16H7.99967V11ZM12.9997 11H11.9997V16H12.9997V11ZM17.9997 11H16.9997V16H17.9997V11ZM18.9997 8.99999H5.99967V9.99999H18.9997V8.99999ZM12.4997 3.14612L3.83203 7.99999H21.1673L12.4997 3.14612Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.62c4a5703294b1c957649f1c740966b5.svg";
export { ForwardRef as ReactComponent };